// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";

import * as serviceSelectors from "@modules/service/selectors";
import actionCreators from "@modules/service/actionCreator";
import type { StepProps } from "@components";
import { StaffGroupsForm } from "@modules/shared/components";
import type { StaffGroup } from "@modules/service/reducer/dynamic-questions/types";

import type { DynamicQuestionContent } from "@modules/service/reducer/dynamic-questions/types";
import { View } from "@components";

type StepData = $Exact<{
  staffGroups: Array<StaffGroup>,
}>;

type OwnProps = $Exact<{
  editing: boolean,
}>;

type PropsFromState = $Exact<{
  draft: ?DynamicQuestionContent,
  schema: ?Object,
}>;

type PropsFromDispatch = $Exact<{
  onUpdateDraft: typeof actionCreators.UpdateDynamicQuestionDraft,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class StepStaffGroups extends React.Component<Props> {
  componentDidMount() {
    if (this.props.onChange) {
      this.props.onChange(this.props.draft || {}, this.props.isValid);
    }
  }

  get staffGroupsList() {
    const staffGroups = this.schema.staffGroups.items.properties.id.oneOf || [];
    return staffGroups.map((staffGroup: { const: number, title: string }) => {
      return {
        id: staffGroup.const,
        name: staffGroup.title,
      };
    });
  }

  get data(): StepData {
    return { staffGroups: (this.props.draft || {}).staffGroups || [] };
  }

  get schema() {
    return { staffGroups: (this.props.schema || {}).properties.staffGroups };
  }

  handleChange = (data: Array<Object>) => {
    const updatedDraft = { ...this.props.draft, staffGroups: data };
    this.props.onUpdateDraft(updatedDraft);
  };

  render() {
    return (
      <View className="gs-container">
        <div className="col-sm-12">
          {this.schema && this.data ? (
            <StaffGroupsForm
              data={this.data.staffGroups}
              options={this.staffGroupsList}
              onChange={this.handleChange}
            />
          ) : null}
        </div>
      </View>
    );
  }
}

const mapStateToProps = (state, ownProps): PropsFromState => {
  return {
    draft: serviceSelectors.getDynamicQuestionDraft(state),
    schema: serviceSelectors.getDynamicQuestionRevisionSchema(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  onUpdateDraft: actionCreators.UpdateDynamicQuestionDraft,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(StepStaffGroups);
